/**
 * Wrapper accessibile per campi di form: label, asterisco "*" obbligatorio,
 * descrizione e messaggio d'errore. Pattern UX coerente con .
 */
import * as React from "react";
import { cn } from "@/lib/utils";

let fieldCounter = 0;
const nextId = () => `form-field-${++fieldCounter}`;

interface FormFieldProps {
  label: React.ReactNode;
  required?: boolean;
  description?: React.ReactNode;
  error?: React.ReactNode;
  className?: string;
  htmlFor?: string;
  children: React.ReactNode | ((args: { id: string }) => React.ReactNode);
}

export function FormField({
  label,
  required,
  description,
  error,
  className,
  htmlFor,
  children,
}: FormFieldProps) {
  const autoId = React.useMemo(() => nextId(), []);
  const id = htmlFor ?? autoId;
  const descId = description ? `${id}-desc` : undefined;
  const errId = error ? `${id}-err` : undefined;

  return (
    <div className={cn("space-y-1.5", className)}>
      <label
        htmlFor={id}
        className="block text-xs font-medium text-foreground"
      >
        {label}
        {required && <span className="ml-0.5 text-destructive">*</span>}
      </label>
      {typeof children === "function"
        ? (children as (args: { id: string }) => React.ReactNode)({ id })
        : children}
      {description && (
        <p id={descId} className="text-[11px] leading-snug text-muted-foreground">
          {description}
        </p>
      )}
      {error && (
        <p id={errId} className="text-[11px] leading-snug text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}
